module.exports = __webpack_public_path__ + "img/top_main.fa8862f6.png";